import React from 'react';
import Navbar from './navbar/Navbar';
import Sidenav from './sidenav/SideNav';
import Home from './home/Home';
import { useState } from 'react';
function Layout() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [navbarColor, setNavbarColor] = useState('#f0f0f0');
  const [sidebarColor, setSidebarColor] = useState('#636d79');
  const [sidebarTextColor, setSidebarTextColor] = useState('#ffffff');
  const [navbarHeadingColor, setNavbarHeadingColor] = useState('#fffff');
  const [cardBackgroundColor, setCardBackgroundColor] = useState("white");

  const collapseSidenav = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const handleColorCombinationChange = (newSidebarColor, newNavbarColor, newTextColor, navbarTextColor, cardColor) => {
    setSidebarColor(newSidebarColor);
    setNavbarColor(newNavbarColor);
    setSidebarTextColor(newTextColor);
    setNavbarHeadingColor(navbarTextColor);
    setCardBackgroundColor(cardColor);
  };

  return (
    <>
      <div className='d-flex'>
        <Sidenav isSidebarCollapsed={isSidebarCollapsed} bgColor={sidebarColor} textColor={sidebarTextColor} />
        <div style={{ width: "100%", transition: 'width 0.3s ease', overflow: 'hidden' }}>
          <Navbar collapseSidenav={collapseSidenav} onColorCombinationChange={handleColorCombinationChange} bgColor={navbarColor} navbarTextHeadingColor={navbarHeadingColor} />
          <Home bgColor={navbarColor} sidebarColor={sidebarColor} cardColor={cardBackgroundColor} />
        </div>
      </div>
    </>
  );
}
export default Layout;
